/**
 * @generated SignedSource<<63b2eee43fc94998001d37e2f3ea47c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetCalendarOverviewEventDeletedSubscription$variables = {
  calendarIds: ReadonlyArray<string>;
  connections: ReadonlyArray<string>;
};
export type WidgetCalendarOverviewEventDeletedSubscription$data = {
  readonly calendarEventDeleted: {
    readonly calendarEvent: {
      readonly id: string;
    };
  } | null;
};
export type WidgetCalendarOverviewEventDeletedSubscription = {
  response: WidgetCalendarOverviewEventDeletedSubscription$data;
  variables: WidgetCalendarOverviewEventDeletedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "calendarIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "calendarIds",
    "variableName": "calendarIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetCalendarOverviewEventDeletedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEventDeletedPayload",
        "kind": "LinkedField",
        "name": "calendarEventDeleted",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarEvent",
            "kind": "LinkedField",
            "name": "calendarEvent",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetCalendarOverviewEventDeletedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEventDeletedPayload",
        "kind": "LinkedField",
        "name": "calendarEventDeleted",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarEvent",
            "kind": "LinkedField",
            "name": "calendarEvent",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a291eedd4d048ab19d2532c4ccce07ad",
    "id": null,
    "metadata": {},
    "name": "WidgetCalendarOverviewEventDeletedSubscription",
    "operationKind": "subscription",
    "text": "subscription WidgetCalendarOverviewEventDeletedSubscription(\n  $calendarIds: [ID!]!\n) {\n  calendarEventDeleted(calendarIds: $calendarIds) {\n    calendarEvent {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1282599e6e1c987fdb38f8700a012995";

export default node;
